import moment from 'moment';

import DropDownFilter from '@/views/Common/Filter/DropDownFilter';

const now = moment().format('YYYY-MM-D');

const endTime = ' 23:59:59';
const startTime = ' 00:00:00';

const today = {
  key: 'today', text: 'Today', value: {
    from: moment().format('YYYY-MM-D') + startTime,
    to: moment().format('YYYY-MM-D') + endTime
  }
};

const options = [
  today,
  {
    key: 'yesterday', text: 'Yesterday', value: {
      from: moment().subtract(1, 'day').format('YYYY-MM-D') + startTime,
      to: moment().subtract(1, 'day').format('YYYY-MM-D') + endTime
    }
  },
  {
    key: 'last_week', text: 'Last Week', value: {
      from: moment().subtract(1, 'week').format('YYYY-MM-D') + startTime,
      to: now + endTime
    }
  },
  {
    key: 'thirty_days', text: 'Last 30 Days', value: {
      from: moment().subtract(30, 'days').format('YYYY-MM-D') + startTime,
      to: now + endTime
    }
  },
  {
    key: 'this_month', text: 'This Month', value: {
      from: moment().startOf('month').format('YYYY-MM-D') + startTime,
      to: moment().endOf('month').format('YYYY-MM-DD') + endTime
    }
  },
  {
    key: 'last_month', text: 'Last Month', value: {
      from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-D') + startTime,
      to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-D') + endTime
    }
  },
  {
    key: 'this_year', text: 'This Year', value: {
      from: moment().startOf('year').format('YYYY-MM-D') + startTime,
      to: moment().endOf('year').format('YYYY-MM-D') + endTime
    }
  },
  {
    key: 'last_year', text: 'Last Year', value: {
      from: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-D') + startTime,
      to: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-D') + endTime
    }
  },
  {
    key: 'all_time', text: 'All Time', value: {
      from: moment().subtract(20, 'year').startOf('year').format('YYYY-MM-D') + startTime,
      to: now + endTime
    }
  },
  // {key: 'custom', text: 'Custom'}
];

console.log(options, 'date filter');

export default {
  data() {
    return {
      dateFilters: {
        options: options,
        default: today,
        key_field: 'created_at'
      }
    }
  },
  components: {
    DropDownFilter
  },

  methods: {
    /**
     * Get the default date values.
     *
     * @return {{text: string, value: {from: string, to: string}, key: string}}
     */
    getDefaultDateValues() {
      return this.dateFilters.default;
    },

    /**
     * Handle the date filter on change.
     * @param date
     */
    handleDateFilter(date) {
      this.setDateFilter(date);
      this.refreshData();
    },


    getToKey() {
      return `${this.dateFilters.key_field}_to`;
    },


    getFromKey() {
      return `${this.dateFilters.key_field}_from`;
    },

    setDateFilterKeyField(key_field) {
      this.dateFilters = {...this.dateFilters, ...{key_field}};
    },

    setDateFilter(date) {
      this.setFilter({
        [this.getFromKey()]: [`${this.dateFilters.key_field},>=,${date.value.from}`],
        [this.getToKey()]: [`${this.dateFilters.key_field},<=,${date.value.to}`]
      });
    },

    setDefaultDateFilter(date) {
      this.dateFilters.default = date;
    },

    initializeDateFilter() {
      this.setDateFilter(this.getDefaultDateValues());
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/with-date-filter.js